import React from "react";
import CourseEventsHeader from "./CourseDetailsHeader";
import CourseEvents from "./CourseEvents";
import CourseBundleDescription from "../courses/CourseBundleDescription";
import striptags from 'striptags';

function EventsDetails({customSections, selectedTimeZone, eventSessions, setTotalLecturesCount, setTotalCoursesCount, bceDescription, bceRefundPolicy, bceCancellationPolicy, className}) {
  return (
    <>
      <div className={`${className || ''} course-inner-bundle`}>
        <CourseEvents selectedTimeZone={selectedTimeZone} setTotalLecturesCount={setTotalLecturesCount} setTotalCoursesCount={setTotalCoursesCount} eventSessions={eventSessions} className="mb-4"/>
        {bceDescription != '' && 
          <CourseBundleDescription className="mb-4" courseBundleDescTitle="Description" courseBundleDesc={bceDescription}/>
        }
        {Object.keys(customSections).length > 0 &&
          Object.keys(customSections).map((key) => {
            return <CourseBundleDescription className="mb-4" courseBundleDescTitle={customSections[key].name} courseBundleDesc={customSections[key].description}/>
          })
        }
        {striptags(bceRefundPolicy).trim() != '' && 
          <CourseBundleDescription className="mb-4" courseBundleDescTitle="Refund Policy" courseBundleDesc={bceRefundPolicy}/>
        }
        {striptags(bceCancellationPolicy).trim() != '' && 
          <CourseBundleDescription className="mb-4" courseBundleDescTitle="Cancellation Policy" courseBundleDesc={bceCancellationPolicy}/>
        }
      </div>
    </>
  );
}

export default EventsDetails;
